<template>
  <div class="required-docs width-responsiveness">
    <div class="required-docs__header">
      <h2>Documentos Obrigatórios</h2>
    </div>

    <RequiredDocsFilter
      :doc-pendent="formData.docPendent"
      @updateList="updatePendentDocList"
    />

    <FakeTab
      :first-active="formData.docPendent"
      first-title="Pendente"
      secound-title="Anexado"
      :disabled="loadingDocs"
      @update="changeTab"
    />

    <div class="required-docs__search-container">
      <div class="search">
        <input
          v-model="filterDocsListInput"
          placeholder="Filtrar listagem..."
          class="search-box__input"
        >
        <img
          src="/static/images/icon-search-purple.svg"
          class="search-box__icon"
        >
      </div>
    </div>

    <RequiredDocsTable
      :loading-docs="loadingDocs"
      :filter-input="filterDocsListInput"
      :data="tableData"
      @refreshPage="refreshPage"
    />
  </div>
</template>

<script>
import RequiredDocsTable from './components/RequiredDocsTable.vue'
import RequiredDocsFilter from './components/RequiredDocsFilter.vue'
import FakeTab from '@/components/common/FakeTab.vue'

import docPendentOrders from '@/api/order'
import notify from '@/api/notification'
import Moment from 'moment'

export default {
  name: 'RequiredDocs',
  components: {
    RequiredDocsTable,
    RequiredDocsFilter,
    FakeTab
  },
  data() {
    return {
      formData: {
        docPendent: true,
        patientName: '',
        osLis: '',
        numberOsAlvaro: '',
        startDate: '',
        endDate: ''
      },
      tableData: [],
      loadingDocs: false,
      filterDocsListInput: ''
    }
  },
  computed: {
    firstTabSelected() {
      return this.currentTab === 'pendente'
    }
  },
  created() {
    localStorage.removeItem('docFilters')
    this.formData['startDate'] = Moment().subtract(1, 'weeks').format('DD/MM/YYYY')
    this.formData['endDate'] = Moment().format('DD/MM/YYYY')
    this.updatePendentDocList(this.formData)
  },
  created() {
    localStorage.removeItem('docFilters')
    this.formData['startDate'] = Moment().subtract(1, 'weeks').format('DD/MM/YYYY')
    this.formData['endDate'] = Moment().format('DD/MM/YYYY')
    localStorage.setItem('docFilters', JSON.stringify(this.formData))
    this.updatePendentDocList(this.formData)
  },
  methods: {
    changeTab(docPendent) {
      this.formData.docPendent = docPendent
      localStorage.setItem('docFilters', JSON.stringify(this.formData))
      this.updatePendentDocList(this.formData)
    },
    refreshPage() {
      const data = JSON.parse(localStorage.getItem('docFilters'))
      if (data) {
        this.updatePendentDocList(data)
      }
    },
    updatePendentDocList(data) {
      this.formData = data
      this.loadingDocs = true
      docPendentOrders
        .getDocPendentOrders(data)
        .then(res => {
          this.tableData = res.data
          this.loadingDocs = false
        })
        .catch(err => {
          this.loadingDocs = false
          notify({
            title: 'AVISO:',
            message: 'Ocorreu um erro no carregamento da lista!'
          })
        })
    }
  }
}
</script>

<style lang="scss">
.required-docs {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  height: calc(100% - 58px);
  margin-top: 100px;

  &__header {
    display: flex;
    width: 100%;
    margin-bottom: 38px;

    h2 {
      font-size: 22px;
      font-weight: 400;
      letter-spacing: -0.3px;
      text-align: left;
      color: #7a7a7a;
      line-height: 30px;
    }
  }

  .fake-tab {
    width: 100%;
  }

  &__search-container {
    display: flex;
    width: 100%;

    .search {
      background-color: #fff;
      padding: 5px 10px;
      border-radius: 5px;
      margin-bottom: 20px;
      width: auto;

      input {
        border: none;
        outline: none;
        min-width: 220px;
      }
    }
  }
}
</style>
